import ufeApi from 'services/api/ufeApi';
import urlUtils from 'utils/Url';
import RCPSCookies from 'utils/RCPSCookies';
import cookieUtils from 'utils/Cookies';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import accessTokenApi from 'services/api/accessToken/accessToken';
import { PROFILE_STATUS_COOKIE_NAME } from 'services/auth/newFlow/constants';

const accessToken = 'AUTH_ACCESS_TOKEN';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+Profile+Full+Information
function getProfileFullInformation(_jwtAccessToken, profileId, options, requestConfig = {}) {
    // For cookie-based auth, check if profileStatus cookie exists (it auto-expires, so existence = valid)
    // For old auth flow, check AUTH_ACCESS_TOKEN in localStorage
    const isUserLoggedIn = RCPSCookies.isRCPSCookieBasedAuthEnabled()
        ? !!(cookieUtils.read(PROFILE_STATUS_COOKIE_NAME) || cookieUtils.read('profileStatus'))
        : !!Storage.local.getItem(LOCAL_STORAGE.AUTH_ACCESS_TOKEN);

    const {
        skipApis, includeApis, includeTargeters, productId, preferedSku, propertiesToInclude, refreshSubscriptions, forceLinkedAccountDetails
    } =
        options;

    const qsParams = {
        skipApis,
        includeApis,
        includeTargeters,
        productId,
        preferedSku,
        propertiesToInclude,
        refreshSubscriptions,
        forceLinkedAccountDetails
    };

    if (!isUserLoggedIn) {
        return Promise.reject(new Error('User is not logged in'));
    }

    const biAccountId =
        Storage.local.getItem(LOCAL_STORAGE.USER_DATA)?.profile?.beautyInsiderAccount?.biAccountId ||
        Storage.local.getItem(LOCAL_STORAGE.BI_ACCOUNT_ID, true);

    const storeId =
        Storage.local.getItem(LOCAL_STORAGE.USER_DATA)?.profile?.preferredStore || Storage.session.getItem(LOCAL_STORAGE.SELECTED_STORE)?.storeId;

    const userProfileId = Storage.local.getItem(LOCAL_STORAGE.PROFILE_ID, true);

    const sameDayZipcodeCookie = cookieUtils.read('sameDayZipcodeCookie');
    const preferredZipCode = sameDayZipcodeCookie || Storage.session.getItem(LOCAL_STORAGE.SELECTED_STORE)?.address?.postalCode;

    let url = `/gapi/users/profiles/${userProfileId}/current/full`;

    // Only append if we have a value
    biAccountId && (qsParams.biAccountId = biAccountId);
    storeId && (qsParams.storeId = storeId);
    preferredZipCode && (qsParams.preferredZipCode = preferredZipCode);
    qsParams.preferenceStruct = 'world';

    const qs = urlUtils.makeQueryString(qsParams);

    if (qs) {
        url += '?' + qs;
    }

    return ufeApi.makeRequest(url, { method: 'GET' }, requestConfig).then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default accessTokenApi.withAccessToken(getProfileFullInformation, accessToken);
